import React from "react";
import Typography from "@common/components/Typography";
import { TFunction } from "react-i18next";
import { Checkbox, TextField } from "@mui/material";
import { ElogAttendance } from "@services/meetings/types";

export const getColumns = (
  onNoShowClick: (id: number, checked: boolean) => void,
  onChangeActualAttendance: (id: number, value: number) => void,
  t: TFunction
): ColDef<ElogAttendance>[] => [
  {
    sortable: false,
    label: "Room Name",
    key: "name",
    render: ({ room }) => (
      <Typography
        size="small"
        sx={{
          textAlign: "center",
        }}
      >
        {room.name ?? ""}
      </Typography>
    ),
  },
  {
    sortable: false,
    label: "Capacity",
    key: "room",
    render: ({ room }) => (
      <Typography
        size="small"
        sx={{
          textAlign: "center",
        }}
      >
        {room.capacity ?? 0}
      </Typography>
    ),
  },
  {
    sortable: false,
    label: "Actual Attendance",
    key: "actualAttendance",
    width: 140,
    render: (row) => (
      <TextField
        fullWidth
        key={`text-attendance-${row.id}`}
        value={row.actualAttendance ?? ""}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const parsed = parseInt(e.target.value);
          onChangeActualAttendance(
            row.id,
            isNaN(parsed) || parsed < 0 ? 0 : parsed
          );
        }}
        slotProps={{
          htmlInput: { maxLength: 255 }
        }}
      />
    ),
  },
  {
    sortable: false,
    label: "No Show",
    key: "id",
    render: (row) => (
      <Checkbox
        key={`chkbox-attendance-${row.id}`}
        checked={row.actualAttendance == 0}
        onChange={(_, checked) => {
          onNoShowClick(row.id, checked);
        }}
      />
    ),
  },
];
